var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group",
        { attrs: { id: "catalog_list" } },
        _vm._l(_vm.catalogs, function(item, index) {
          return _c(
            "b-list-group-item",
            { key: index },
            [
              _c("h5", [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c(
                "b-list-group",
                {
                  staticClass: "text-small list-group-striped",
                  attrs: { id: "catalog-items-list" }
                },
                _vm._l(item.items, function(item, index) {
                  return _vm.hasPermission(item.perms)
                    ? _c(
                        "b-list-group-item",
                        { key: index, attrs: { to: { path: item.path } } },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            staticStyle: { color: "black" },
                            attrs: { icon: "list" }
                          }),
                          _vm._v(
                            "\n          " + _vm._s(item.name) + "\n        "
                          )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa59a75c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa59a75c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/CatalogList.vue
// module id = null
// module chunks = 